<template>
    <div>
        <v-row v-if="!isConnector()" class="pt-4">
            <v-col>
                <eod-text-field :rules="!isConnector() ? [val => $validator.required(val, 'Voornaam')] : []" :value="value.firstName"
                    :label="'Voornaam' + (!isConnector() ? '*' : '')" outlined hide-details="auto" @input="setFirstName"></eod-text-field>
            </v-col>
            <v-col>
                <eod-text-field :rules="!isConnector() ? [val => $validator.required(val, 'Familienaam')] : []" :value="value.lastName"
                    :label="'Familienaam' + (!isConnector() ? '*' : '')" outlined hide-details="auto"
                    @input="setLastName"></eod-text-field>
            </v-col>
            <v-col>
                <eod-text-field
                    :value="getAttribute('jobtitle')" label="Jobtitel" outlined hide-details
                    @input="val => setAttribute('jobtitle', val)"></eod-text-field>
            </v-col>
        </v-row>
        <v-row v-if="!isConnector()">
            <v-col>
                <eod-text-field :value="value.email" :label="'E-mailadres' + (!isConnector() ? '*' : '')" type="email"
                    :rules="[val => $validator.required(val, 'E-mailadres'), val => $validator.email(val, 'E-mailadres')]" outlined hide-details="auto" name="email"
                    autocomplete="off" @input="val => setProperty('email', val)"></eod-text-field>
            </v-col>
            <v-col>
                <eod-text-field :disabled="value.id ? true : (isGuest() && !usernameExists)" :value="value.username"
                    label="Gebruikersnaam" :rules="value.id ? [] : [val => $validator.required(val, 'Gebruikersnaam')]" outlined
                    hide-details="auto" name="username" autocomplete="off"
                    @input="val => setProperty('username', val)"></eod-text-field>
            </v-col>
            <v-col>
                <eod-autocomplete label="Taal" :value="getAttribute('locale')" @input="val => setAttribute('locale', val)" :items="$eod.getLanguages()">

                </eod-autocomplete>
            </v-col>
        </v-row>
        <v-row v-if="!isConnector()">
            <v-col>
                <eod-phone-field :value="getAttribute('phone_number')" label="Telefoon"
                    @input="val => setAttribute('phone_number', val)"></eod-phone-field>
            </v-col>
            <v-col>
                    <eod-phone-field :value="getAttribute('extra_phone')" label="Extra telefoon"
                    @input="val => setAttribute('extra_phone', val)"></eod-phone-field>
                </v-col>
        </v-row>
        <v-row v-if="isConnector()">
            <v-col>
                <eod-text-field :value="value.name" label="Naam*" outlined hide-details="auto"
                    :rules="[val => $validator.required(val, 'Naam')]" @input="val => setProperty('name', val)"></eod-text-field>
            </v-col>
        </v-row>
        <v-row v-if="role && value.assignedRealmRoles">
            <v-col>
                <v-select :key="'role_' + roleSelectKey" @change="val => changeRole(val)" outlined dense hide-details="auto" :rules="[val => $validator.required(val, 'Rol')]"
                    label="Rol*" :items="roleItems" :item-text="getRoleName" return-object
                    :value="value.assignedRealmRoles[0]"></v-select>
            </v-col>
        </v-row>
        <eod-dialog v-if="pendingRole" :value="true" persistent width="560" icon="mdi-account-switch-outline" icon-color="warning"
            :title="switchToContact ? 'Wijzigen naar contact?' : 'Wijzigen naar medewerker?'" okText="Rol wijzigen"
            @okAction="confirmRoleSwitch" @cancelAction="cancelRoleSwitch">
            <template v-if="switchToContact">
                <p>Je wijzigt de rol van deze medewerker naar <strong>{{ getRoleName(pendingRole) }}</strong>. Een contact ziet enkel de bedrijven en projecten die in het tabblad <em>Toegang</em> aan hem gekoppeld zijn, en verhuist naar de lijst met contacten.</p>
                <p class="mb-0">Adres, vaardigheden, beschikbaarheid en alle andere koppelingen blijven bewaard. Je kan dus later zonder verlies terugschakelen.</p>
            </template>
            <template v-else>
                <p>Je wijzigt de rol van dit contact naar <strong>{{ getRoleName(pendingRole) }}</strong>. Een contact ziet enkel de bedrijven en projecten waaraan het gekoppeld is; een medewerker krijgt toegang tot de <strong>volledige organisatie</strong> en verhuist naar de lijst met medewerkers.</p>
                <p class="mb-0">De koppelingen in het tabblad <em>Toegang</em> blijven bewaard. Je kan dus later zonder verlies terugschakelen.</p>
            </template>
        </eod-dialog>
        <v-row v-if="!isGuest() || value.id">
            <v-col>
                <eod-text-field :value="value.credentials?.value" label="Wachtwoord"
                    :rules="[passwordMatch]"
                    :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" outlined hide-details="auto" name="password"
                    autocomplete="new-password" @input="val => setPassword(val)"></eod-text-field>
            </v-col>
            <v-col>
                <eod-text-field :value="repeatPassword" label="Herhaal wachtwoord"
                    :rules="[passwordMatch]"
                    :type="showRepeatPassword ? 'text' : 'password'"
                    @click:append="showRepeatPassword = !showRepeatPassword"
                    :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'" outlined hide-details="auto"
                    autocomplete="new-password" @input="val => setRepeatPassword(val)"></eod-text-field>

            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <eod-textarea :value="getAttribute('notes')" label="Notities" @input="val => setAttribute('notes', val)" info="Informatieve gegevens die aan het gebruikersprofiel worden gekoppeld"></eod-textarea>
            </v-col>
            <v-col v-if="isConnector()">
                <v-textarea :value="getAttribute('description')" label="Omschrijving" outlined hide-details
                    @input="val => setAttribute('description', val)"></v-textarea>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import eodPhoneField from './eod-phone-field.vue';
import eodDialog from './eod-dialog.vue';
import settings from './../classes/settings';

export default {
    components: {
        eodPhoneField,
        eodDialog,
    },
    props: {
        value: Object,
        role: {
            default: false,
            type: Boolean
        },
        usernameExists: {
            default: false,
            type: Boolean
        },
        roles: Array,
        // Laat toe om een bestaande gebruiker te wisselen tussen contact en medewerker.
        allowRoleSwitch: {
            default: false,
            type: Boolean
        }
    },
    data: () => ({
        showBirthdatePickerMenu: false,
        allRoles: [],
        initialRoleName: null,
        pendingRole: null,
        roleSelectKey: 0,
        showRepeatPassword: false,
        showPassword: false,
        repeatPassword: null,
    }),
    created() {
        this.initialRoleName = this.value.assignedRealmRoles?.[0]?.name || null;

        if (this.role) {
            this.$eod.getRoles().then(result => {
                this.allRoles = result;

                if (this.rolesList[0] && !this.value.assignedRealmRoles?.[0]) {
                    // Enkel bij een nieuwe gebruiker een standaardrol invullen. Een bestaande
                    // gebruiker zonder rol krijgt er nooit stilzwijgend een toegewezen (de
                    // autosave zou die meteen wegschrijven): dat is een expliciete keuze.
                    if (!this.value.id) {
                        this.setRole(this.rolesList[0]);
                    }
                } else if (this.rolesList[0] && this.value.assignedRealmRoles && this.value.assignedRealmRoles[0]){
                    // Bugfix client roles instead of global roles
                    const role = this.rolesList.filter(role => role.name == this.value.assignedRealmRoles[0].name)?.[0];
                    if(role && role.id != this.value.assignedRealmRoles[0].id){
                        this.setRole(role);
                    } else if (!role && !this.value.id) {
                        // De vooringevulde standaardrol is niet lager dan de eigen rol: de eerste toegelaten rol nemen.
                        this.setRole(this.rolesList[0]);
                    }
                }
            });
        } else if (this.roles && (!this.value.assignedRealmRoles || !this.value.assignedRealmRoles[0])) {
            this.setRole({ name: this.roles[0] });
        }
    },
    computed: {
        allowedRoleNames() {
            let names = [];
            if (this.roles) {
                names = [...this.roles];
            } else {
                names = this.allRoles.map(role => role.name).filter(name => !settings.roles.exception.includes(name) && !settings.roles.eod.includes(name) && !settings.roles.anonymous.includes(name));
            }

            if (this.value.id) {
                // Wisselen tussen contact en medewerker: enkel voor bestaande gebruikers, en niet
                // voor rollen buiten die groepen (bv. connector, die aan een EngineFlow hangt).
                const initialGroup = settings.getRoleGroupName(this.initialRoleName);
                if (this.allowRoleSwitch && (!this.initialRoleName || settings.switchableRoleGroups.includes(initialGroup))) {
                    for (const groupName of settings.switchableRoleGroups) {
                        names.push(...settings.roles[groupName]);
                    }
                }
            }

            // Enkel rollen toekennen die lager zijn dan de eigen rol van de ingelogde gebruiker (een
            // beheerder mag ook beheerder toekennen).
            const ownRole = this.$eod.getUser().getRole();
            names = settings.filterManageableRoleNames(names, ownRole ? ownRole.name : null);

            if (this.value.id) {
                // De huidige rol altijd aanbieden, zodat het veld nooit leeg (en verplicht) toont
                // voor een gebruiker die via een ander scherm geopend wordt.
                if (this.initialRoleName) {
                    names.push(this.initialRoleName);
                }
            }

            return [...new Set(names)];
        },
        rolesList() {
            return this.allRoles.filter(role => this.allowedRoleNames.includes(role.name));
        },
        roleItems() {
            const groups = {};
            for (const role of this.rolesList) {
                const groupName = settings.getRoleGroupName(role.name);
                if (!groups[groupName]) {
                    groups[groupName] = [];
                }
                groups[groupName].push(role);
            }

            const groupNames = Object.keys(groups);
            if (groupNames.length < 2) {
                return this.rolesList;
            }

            // Meerdere groepen: de groep van het huidige scherm eerst, met een kop per groep.
            const ownGroup = this.roles && this.roles[0] ? settings.getRoleGroupName(this.roles[0]) : null;
            groupNames.sort((a, b) => (b == ownGroup) - (a == ownGroup));

            const items = [];
            for (const groupName of groupNames) {
                if (items.length > 0) {
                    items.push({ divider: true });
                }
                items.push({ header: settings.roleGroupLabels[groupName] || this.$t(groupName) });
                items.push(...groups[groupName]);
            }

            return items;
        },
        switchToContact() {
            return this.pendingRole && settings.getRoleGroupName(this.pendingRole.name) == 'contacts';
        },
    },
    watch: {
        showBirthdatePickerMenu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
    },
    methods: {
        isConnector() {
            if (this.value && this.value.assignedRealmRoles) {
                for (let i = 0; i < this.value.assignedRealmRoles.length; i++) {
                const role = this.value.assignedRealmRoles[i];
                    if(role.name == 'connector'){
                        return true;
                    }
                }
            }
            
            return false;
        },
        isGuest() {
            if (this.value && this.value.assignedRealmRoles) {
                for (let i = 0; i < this.value.assignedRealmRoles.length; i++) {
                const role = this.value.assignedRealmRoles[i];
                    if(role.name == 'contributor' || role.name == 'responsible'){
                        return true;
                    }
                }
            }

            return false;
        },
        getRoleName(role) {
            return this.$t(role.name);
        },
        passwordMatch(value) {

            if(!this.value.credentials?.value && !value){
                return true;
            }
            
            return this.value.credentials?.value == value || 'Beide wachtwoorden komen niet overeen.';
        },
        setFirstName(val) {
            if (!this.value.id) {
                this.setProperty('username', (val + '.' + (this.value.lastName?this.value.lastName:'')).toLowerCase());
            }

            this.setProperty('firstName', val);
        },
        setLastName(val) {
            if (!this.value.id) {
                this.setProperty('username', ((this.value.firstName?this.value.firstName:'') + '.' + val).toLowerCase());
            }

            this.setProperty('lastName', val);
        },
        setPassword(value) {
            let item = this.value;

            if(value == '' || !value){
                delete item.credentials;
            } else {
                item.credentials = {
                    temporary: false,
                    type: 'password',
                    value: value
                }
            }

            this.$emit('input', item);
        },
        setRepeatPassword(value) {
            // Gecontroleerde waarde, zodat de herhaal-validatie (passwordMatch) niet
            // desynct bij de her-render, en wijzigen ervan de autosave triggert.
            this.repeatPassword = value;
            this.$emit('input', this.value);
        },
        saveBirthdate(date) {
            this.$refs.menu.save(date)
            this.setAttribute('birthdate', date);
        },
        setProperty(propertyName, value) {
            let item = this.value;
            item[propertyName] = value;
            this.$emit('input', item);
            this.$nextTick(this.$forceUpdate);
        },
        changeRole(role) {
            const currentRole = this.value.assignedRealmRoles?.[0];
            const currentGroup = currentRole ? settings.getRoleGroupName(currentRole.name) : null;
            const newGroup = settings.getRoleGroupName(role.name);

            // Contact <-> medewerker wijzigt wat de gebruiker te zien krijgt: eerst bevestigen.
            if (this.value.id && currentGroup && currentGroup != newGroup
                && settings.switchableRoleGroups.includes(currentGroup) && settings.switchableRoleGroups.includes(newGroup)) {
                this.pendingRole = role;
                return;
            }

            this.setRole(role);
        },
        confirmRoleSwitch() {
            const role = this.pendingRole;
            this.pendingRole = null;
            this.setRole(role);
        },
        cancelRoleSwitch() {
            this.pendingRole = null;
            // De v-select houdt intern de gekozen waarde bij: opnieuw opbouwen om de huidige rol te tonen.
            this.roleSelectKey++;
        },
        setRole(value) {
            let item = this.value;
            if(!item.assignedRealmRoles){
                item.assignedRealmRoles = [];
            }
            item.assignedRealmRoles[0] = value;

            this.$emit('input', item);

            this.$nextTick(this.$forceUpdate);
        },
        getAttribute(attrName){
            if(this.value.attributes && this.value.attributes[attrName]){
                return this.value.attributes[attrName][0];
            }

            return null;
        },
        setAttribute(attrName, value) {
            let item = this.value;

            if(!item.attributes){
                item.attributes = {};
            }

            if(!item.attributes[attrName]){
                item.attributes[attrName] = [];
            }

            item.attributes[attrName][0] = value;
            this.$emit('input', item);
        }
    },
}
</script>
